export const platformList = [
	"Amazon/ Flipkart/ Meesho/ Other Marketplace",
	"Own Website",
	"None"
];

export const categoryList = [
	"Apparel",
	"Home Decor/ Furnishing/Kitchen",
	"Women's accessories",
	"Health & Fitness",
	"FMCG/ Consumer Goods",
	"Beauty & Cosmetics"
];

export const numbersOfOrderList = ["0", "<500", "500-5000", "5000+"];

export const SELLER_MARKETPLACE_URL_VALIDATION_REGEX = {
	flipkart_product_links: /^(https?:\/\/)(www\.)?flipkart\.com.*\/p\/.*$/,
	myntra_product_links:
	  /^(https?:\/\/)(www\.)?myntra\.com\/[a-zA-Z0-9-+]+\/[a-zA-Z0-9-+]+\/[a-zA-Z0-9-+]+\/(\d+)\/buy$/,
	ajio_product_links: /^(https?:\/\/)(www\.)?ajio\.com.*\/p\/.+$/,
	meesho_store_links: /^(https?:\/\/)(www\.)?meesho\.com\/?(?!.*\/p\/).*$/,
	indiamart_store_links:
	  /^(https?:\/\/)(www\.)?indiamart\.com(?!.*\/proddetail\/).*$/,
	amazon_store_links: /^(https?:\/\/)(www\.)?amazon\.in\/l\/.+/,
	amazon_brand_links: /^(https?:\/\/)(www\.)?amazon\.in\/stores\/.+/,
	amazon_product_links: /^(https?:\/\/)(www\.)?amazon\.in\/?.*$/,
};

// Helper function to validate URLs smartly
export const validateProductUrl = (url: string): boolean => {
	if (!url) return false;
	
	// Basic URL validation regex - only allow HTTPS
	//use in
	const basicUrlRegex = /^(https:\/\/)([\w.-]+)\.([a-z]{2,})(\S*)?$/i;
	
	// Check if it's a valid URL format first
	if (!basicUrlRegex.test(url)) {
		return false;
	}
	
	// Extract domain from URL
	const domainMatch = url.match(/^https?:\/\/(www\.)?(.*?)(\/.*)?$/);
	if (!domainMatch) return false;
	
	const domain = domainMatch[2].toLowerCase();
	
	// Check if it's a known marketplace domain
	const marketplaceDomains = {
		'flipkart.com': [SELLER_MARKETPLACE_URL_VALIDATION_REGEX.flipkart_product_links],
		'myntra.com': [SELLER_MARKETPLACE_URL_VALIDATION_REGEX.myntra_product_links],
		'ajio.com': [SELLER_MARKETPLACE_URL_VALIDATION_REGEX.ajio_product_links],
		'meesho.com': [SELLER_MARKETPLACE_URL_VALIDATION_REGEX.meesho_store_links],
		'indiamart.com': [SELLER_MARKETPLACE_URL_VALIDATION_REGEX.indiamart_store_links]
	};
	
	// Special handling for Amazon domains - check if it contains 'amazon' and validate against Amazon patterns
	if (domain.includes('amazon')) {
		const amazonPatterns = [
			SELLER_MARKETPLACE_URL_VALIDATION_REGEX.amazon_store_links,
			SELLER_MARKETPLACE_URL_VALIDATION_REGEX.amazon_brand_links,
			SELLER_MARKETPLACE_URL_VALIDATION_REGEX.amazon_product_links
		];
		return amazonPatterns.some(pattern => pattern.test(url));
	}
	
	// If it's a known marketplace, validate against specific patterns
	for (const [marketplaceDomain, patterns] of Object.entries(marketplaceDomains)) {
		if (domain === marketplaceDomain) {
			return patterns.some(pattern => pattern.test(url));
		}
	}
	
	// Reject URLs that look like marketplace domains but have wrong TLD
	const marketplaceNames = ['flipkart', 'myntra', 'ajio', 'meesho', 'indiamart'];
	for (const name of marketplaceNames) {
		if (domain.includes(name) && !domain.endsWith(`${name}.com`)) {
			// Domain contains marketplace name but doesn't end with correct .com TLD
			return false;
		}
	}
	
	// If it's not a known marketplace, just check if it's a valid URL
	return true;
};  